<template>
  <div>
    <CCard class="p-4">
      <CRow>
        <CCol lg="6">
          <h5 class="mb-0">SSS Contribution Table</h5>
        </CCol>
        <CCol lg="6">
          <div style="text-align: right">
            <CButton class="mr-1" color="btn btn-info" size="sm" @click="print">
              <i class="fa fa-print"></i> Print
            </CButton>
            <CButton
              v-if="config.getPermission('sss').download"
              size="sm"
              style="margin-right: 10px"
              color="btn btn-outline-primary"
              @click="download()"
              class="float-lg-right"
            >
              <i class="fa fa-download"></i> Download
            </CButton>
          </div>
        </CCol>
      </CRow>

      <hr />

      <CRow>
        <CCol lg="12" class="text-center" v-if="isLoading">
          <div class="spinner-border m-5" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </CCol>
        <CCol lg="12" v-else>
          <div
            id="month_print"
            class="table-responsive-sm table-responsive-md"
          >
            <table class="table table-bordered table-sm text-center sss-contrib-table mb-0">
              <thead>
                <tr>
                  <th rowspan="3" class="sss-th-range align-middle text-uppercase">
                    Range of Compensation
                  </th>
                  <th colspan="8" class="sss-th-title">SSS Table Contributions</th>
                </tr>
                <tr>
                  <th colspan="4" class="sss-th-employer text-uppercase">Employer</th>
                  <th colspan="3" class="sss-th-employee text-uppercase">Employee</th>
                  <th rowspan="2" class="sss-th-grand-total align-middle text-uppercase">
                    Total
                  </th>
                </tr>
                <tr>
                  <th class="sss-col-regular-ss">Regular SS</th>
                  <th class="sss-col-mpf">MPF</th>
                  <th class="sss-col-ec">EC</th>
                  <th class="sss-col-subtotal">Total</th>
                  <th class="sss-col-regular-ss">Regular SS</th>
                  <th class="sss-col-mpf">MPF</th>
                  <th class="sss-col-subtotal">Total</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) of normalizedRows" :key="index">
                  <td>{{ formatAmt(row.range) }}</td>
                  <td>{{ formatAmt(row.employerRegularSs) }}</td>
                  <td>{{ formatAmt(row.employerMpf) }}</td>
                  <td>{{ formatAmt(row.employerEc) }}</td>
                  <td>{{ formatAmt(row.employerTotal) }}</td>
                  <td>{{ formatAmt(row.employeeRegularSs) }}</td>
                  <td>{{ formatAmt(row.employeeMpf) }}</td>
                  <td>{{ formatAmt(row.employeeTotal) }}</td>
                  <td>{{ formatAmt(row.grandTotal) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </CCol>
      </CRow>
    </CCard>
  </div>
</template>

<script>
import config from "../../config.js";
import axios from "../../axios";
import { normalizeSssContributionRow } from "./sss-table-format.js";

export default {
  name: "Tables",
  data() {
    return {
      contribution_table: [],
      isLoading: false,
      config,
      currentPage: 1,
      showCollapse: false,
    };
  },
  computed: {
    normalizedRows() {
      return (this.contribution_table || []).map((item) =>
        normalizeSssContributionRow(item)
      );
    },
  },
  mounted() {
    this.getContributionTable();
  },
  methods: {
    formatAmt(val) {
      if (val === null || val === undefined || val === "") return "—";
      return this.$options.filters.number_format(val, false, 2);
    },
    getContributionTable() {
      this.isLoading = true;
      this.$showLoading(true);
      axios
        .get(config.api_path + "/sss/contribution/table")
        .then((res) => {
          const body = res.data;
          const rows = Array.isArray(body)
            ? body
            : body && Array.isArray(body.data)
              ? body.data
              : [];
          this.contribution_table = rows;
        })
        .finally(() => {
          this.isLoading = false;
          this.$showLoading(false);
        });
    },
    download() {
      this.$showLoading(true);
      axios
        .get(config.api_path + "/sss/contribution/download")
        .then((response) => {
          window.open(
            config.main_path.replace("/index.php", "") + "/" + response.data.file
          );
          setTimeout(() => {
            axios.get(`${config.api_path}/remove-file`, {
              params: { filename: response.data.file },
            });
          }, 2000);
        })
        .catch(() => {})
        .finally(() => {
          this.$showLoading(false);
        });
    },
    print() {
      const el = document.getElementById("month_print");
      if (!el) return;
      const mywindow = window.open("", "PRINT");
      mywindow.document.write("<html><head>");
      mywindow.document.write(
        '<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.0/dist/css/bootstrap.min.css" integrity="sha384-KyZXEAg3QhqLMpG8r+8fhAXLRk2vvoC2f3B09zVXn8CA5QIVfZOJ3BCsw2P0p/We" crossorigin="anonymous">'
      );
      mywindow.document.write(
        '<link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css">'
      );
      mywindow.document.write("</head><body>");
      mywindow.document.write(el.innerHTML);
      mywindow.document.write("</body></html>");
      mywindow.document.close();
      mywindow.focus();
      mywindow.print();
      mywindow.close();
    },
  },
};
</script>

<style scoped>
.sss-contrib-table >>> thead th {
  font-size: 0.75rem;
  vertical-align: middle;
  padding: 0.45rem 0.35rem;
}
.sss-contrib-table >>> tbody td {
  font-size: 0.8125rem;
  padding: 0.4rem 0.35rem;
}
.sss-contrib-table >>> .sss-th-range {
  background: #f8f9fa;
  font-weight: 700;
  min-width: 8rem;
}
.sss-contrib-table >>> .sss-th-title {
  background: #2c8f9e;
  color: #fff;
  font-weight: 700;
  letter-spacing: 0.03em;
}
.sss-contrib-table >>> .sss-th-employer {
  background: #fd9e4f;
  color: #212529;
  font-weight: 700;
}
.sss-contrib-table >>> .sss-th-employee {
  background: #ced4da;
  color: #212529;
  font-weight: 700;
}
.sss-contrib-table >>> .sss-th-grand-total {
  background: #fd9e4f;
  color: #212529;
  font-weight: 700;
}
.sss-contrib-table >>> .sss-col-regular-ss {
  background: #e7f1ff;
  font-weight: 600;
}
.sss-contrib-table >>> .sss-col-mpf {
  background: #fde8e8;
  font-weight: 600;
}
.sss-contrib-table >>> .sss-col-ec {
  background: #fff8e6;
  font-weight: 600;
}
.sss-contrib-table >>> .sss-col-subtotal {
  background: #212529;
  color: #fff;
  font-weight: 700;
}
</style>
